import React from "react";
import PublicPage from "../../public/PublicPage";
import ProfilePage from "../../public/pages/ProfilePage";

const Profile = () => (
  <PublicPage>
    <ProfilePage />
  </PublicPage>
);

export default Profile;
